(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/objectWithoutProperties', 'react', './withAuthProvider', './Spinner', './utils', './PrivateRoute'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/objectWithoutProperties'), require('react'), require('./withAuthProvider'), require('./Spinner'), require('./utils'), require('./PrivateRoute'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.objectWithoutProperties, global.react, global.withAuthProvider, global.Spinner, global.utils, global.PrivateRoute);
    global.PrivateRouteGatsby = mod.exports;
  }
})(this, function (exports, _objectWithoutProperties2, _react, _withAuthProvider, _Spinner, _utils, _PrivateRoute) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.PrivateRouteGatsby = undefined;

  var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

  var _react2 = _interopRequireDefault(_react);

  var _withAuthProvider2 = _interopRequireDefault(_withAuthProvider);

  var _Spinner2 = _interopRequireDefault(_Spinner);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var PrivateRouteGatsby = function PrivateRouteGatsby(_ref) {
    var authReady = _ref.authReady,
        returnTo = _ref.returnTo,
        _ref$loader = _ref.loader,
        Loader = _ref$loader === undefined ? _Spinner2.default : _ref$loader,
        PrivateComponent = _ref.component,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['authReady', 'returnTo', 'loader', 'component']);
    return !authReady ? _react2.default.createElement(Loader, null) : (0, _utils.checkLogin)(rest) ? PrivateComponent : _react2.default.createElement(_PrivateRoute.RedirectToLogin, { returnTo: returnTo });
  };
  exports.PrivateRouteGatsby = PrivateRouteGatsby;
  exports.default = (0, _withAuthProvider2.default)(PrivateRouteGatsby);
});